import { createHash } from 'crypto';
import { Address } from 'shared/types/account';

export class StringHelpers {
  /**
   * isNumeric tests a string and returns true when it's a decimal value
   */
  static isNumeric = (val: string) => !isNaN(+val);

  /**
   * capitaliseFirstLetter capitalises only the very first character of a string, leaving the
   * rest unedited
   */
  static capitalise = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);

  static hyphenToCamelCase = (val: string) => val.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  static phoneDisplayFormat = (input: string): string => {
    const match =
      input.match(/(\d+)\s(\d{3})(\d{3})(\d{4})/) ||
      input.match(/\+(\d{1})\s(\d{3})(\d{3})(\d{4})/) ||
      input.match(/(\d{1})\s(\d{3})(\d{3})(\d{4})/);
    const matchWithoutExt = input.match(/(\d{3})(\d{3})(\d{4})/);
    if (match) {
      const [, countryCode, areaCode, firstPart, secondPart] = match;
      return `(${areaCode}) ${firstPart}-${secondPart} ext ${countryCode}`;
    } else if (matchWithoutExt) {
      const [, areaCode, firstPart, secondPart] = matchWithoutExt;
      return `(${areaCode}) ${firstPart}-${secondPart}`;
    }

    return input;
  };

  static phoneExtensionSplitter = (address: Address) => {
    if (!address || !address.phone) {
      return address;
    }
    // Prevent to modify the original value
    const newAddress = { ...address };
    const strArray = address?.phone?.split(' ');
    if (strArray?.length === 2) {
      newAddress.extension = strArray[0];
      newAddress.phone = strArray[1];
    } else if (strArray?.length === 1) {
      newAddress.phone = strArray[0];
    }
    return newAddress;
  };
}
